'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002ecomponents$002e$002dMeal$002dPlanner$0024$002dRetry$002dDuplicate from "./mealorama.components.-Meal-Planner$-Retry-Duplicate.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MealPlanner$Backend$$anon$1(retries$3, searchParams$5, state$15, meal$40, course$29, outer) {
  this.ZG = 0;
  this.amw = null;
  this.amx = null;
  this.amv = null;
  this.amu = null;
  this.amt = null;
  this.ZG = retries$3;
  this.amw = searchParams$5;
  this.amx = state$15;
  this.amv = meal$40;
  this.amu = course$29;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.amt = outer;
}
export { $c_Lmealorama_components_MealPlanner$Backend$$anon$1 as $c_Lmealorama_components_MealPlanner$Backend$$anon$1 };
$p = $c_Lmealorama_components_MealPlanner$Backend$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lmealorama_components_MealPlanner$Backend$$anon$1;
/** @constructor */
function $h_Lmealorama_components_MealPlanner$Backend$$anon$1() {
}
export { $h_Lmealorama_components_MealPlanner$Backend$$anon$1 as $h_Lmealorama_components_MealPlanner$Backend$$anon$1 };
$h_Lmealorama_components_MealPlanner$Backend$$anon$1.prototype = $p;
$p.Ow = (function(x) {
  if ((x instanceof $j_mealorama$002ecomponents$002e$002dMeal$002dPlanner$0024$002dRetry$002dDuplicate.$c_Lmealorama_components_MealPlanner$RetryDuplicate)) {
    if ((x.zp < this.ZG)) {
      return true;
    }
  }
  return false;
});
$p.NS = (function(x, default$1) {
  if ((x instanceof $j_mealorama$002ecomponents$002e$002dMeal$002dPlanner$0024$002dRetry$002dDuplicate.$c_Lmealorama_components_MealPlanner$RetryDuplicate)) {
    var x35 = x.zp;
    if ((x35 < this.ZG)) {
      var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var message$proxy1 = (("Count " + x35) + " got a duplicate, retrying");
      var optionalParams$proxy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().cr(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([]));
      var f$proxy5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        console.info(message$proxy1, ...$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sjsr_Compat$().eD(optionalParams$proxy1));
      }));
      var ev$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljapgolly_scalajs_react_callback_AsyncCallback($x_1.hY(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljapgolly_scalajs_react_callback_CallbackTo(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_util_Trampoline$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljapgolly_scalajs_react_util_Trampoline$Delay(f$proxy5))).o)).ac;
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljapgolly_scalajs_react_callback_AsyncCallback($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_callback_AsyncCallback$().hW(ev$8, this.amt.aFA(this.ZG, this.amw, this.amx, this.amv, this.amu, ((1 + x35) | 0))));
    }
  }
  return default$1.d(x);
});
$p.Q = (function(x) {
  return this.Ow(x);
});
$p.N = (function(x, default$1) {
  return this.NS(x, default$1);
});
var $d_Lmealorama_components_MealPlanner$Backend$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MealPlanner$Backend$$anon$1, "mealorama.components.MealPlanner$Backend$$anon$1", ({
  Hp: 1,
  k: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lmealorama_components_MealPlanner$Backend$$anon$1 as $d_Lmealorama_components_MealPlanner$Backend$$anon$1 };
//# sourceMappingURL=mealorama.components.-Meal-Planner$-Backend$$anon$1.js.map
